module.exports = __webpack_public_path__ + "static/media/main.7f59526c.png";